export default "__VITE_ASSET__BB7J5XFg__"